<template>
    <div class="tooltip">
        <slot></slot>
        <span class="tooltiptext">{{ txt }}</span>
    </div>
</template>

<script>
export default {
    props: ["txt"],
}
</script>

<style scoped>

.tooltip {
    position: relative;
    cursor: default;
    overflow: visible;
}

.tooltip .tooltiptext {
    z-index: -1;
    visibility: hidden;
    /* Masqué par défaut */
    background-color: #29B6CE;
    color: #fff;
    text-align: center;
    padding: 2px 5px;
    border-radius: 2px;
    font-size: 12px;
    min-width: 130px;

    /* Positionnement */
    position: absolute;
    z-index: 1;
    bottom: 125%;
    /* Place le tooltip au-dessus du bouton */
    left: 50%;
    transform: translateX(-50%);
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>